import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import withLatencyTest from '../hooks/withLatencyTest'
import PageFrontOverviewWrapper from './PageFrontOverviewWrapper'
import PageOverviewMovie from '../PageOverview/PageOverviewMovie'
import { filterWeischerAds } from '../functions/weischerHelpers'
import getAdvertisementData from '../functions/getAdvertisementData'
import { WEISCHER_OVERVIEW_HERO } from '../constants/weischerTypes'
import { ADVERTISEMENT_OVERVIEW_HERO } from '../constants/advertisementTypes'
import getCookie from '../functions/getCookie'
import EntryPagesChildClass from '../General/EntryPagesChildClass'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData';
import { ADVERTISEMENT_CONFIG, FEATURES, FRONT, FRONT_MOBILE_SETTINGS, PROGRAM_ADS, PROGRAM_ADVERTISEMENTS, PROGRAM_COLLECTIONS_ITEMS, PROGRAM_HIGHLIGHTS, PROGRAM_MOVIES, PROGRAM_SELECTIONS_ITEMS, PROGRAM_SELECTIONSDISPLAY, PROGRAM_WEISCHERADS, ROUTESDATA, SITEHEADERDATA, THEME, TRANSLATION } from '../constants/state';
import hasCookieCheck from '../functions/hasCookieCheck';
import { setYoutubeCookieConfirmation } from '../actions';
import withUseCssVars from '../hooks/withUseCssVars'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setYoutubeCookieConfirmation: (bool) => {
        dispatch(setYoutubeCookieConfirmation(bool))
    }
})

const mapStateToProps = (state, ownProps) => ({
    itemCollections: getData(state, PROGRAM_COLLECTIONS_ITEMS), 
    itemSelections: getData(state, PROGRAM_SELECTIONS_ITEMS), 
    itemSelectionsDisplay: getData(state, PROGRAM_SELECTIONSDISPLAY), 
    cinemaDataFront: getData(state, FRONT),
    movies: getData(state, PROGRAM_MOVIES),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS),
    features: getData(state, FEATURES),
    weischerAds: getData(state, PROGRAM_WEISCHERADS),
    theme: getData(state, THEME),
    routesData: getData(state, ROUTESDATA),
    translation: getData(state, TRANSLATION),
    advertisementConfig: getData(state, ADVERTISEMENT_CONFIG),
    siteHeaderData: getData(state, SITEHEADERDATA),
    ads: getData(state, PROGRAM_ADS), 
    highlights: getData(state, PROGRAM_HIGHLIGHTS), 
    frontMobileSetting: getData(state, FRONT_MOBILE_SETTINGS), 
})
class PageFrontOverview extends EntryPagesChildClass {
    constructor(props) {
        super(props)

        this.state = {
            isScrolled: false
        }

        this.onScrollPage = this.onScrollPage.bind(this)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScrollPage)
        
        const { setYoutubeCookieConfirmation } = this.props
        window.addEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage)

        const { setYoutubeCookieConfirmation } = this.props
        window.removeEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }

    onScrollPage() {
        if (window.scrollY > window.innerHeight && this.state.isScrolled === false) {
            this.setState({
                isScrolled: true
            })
        }
    }

    render() {
        const { 
            isOverviewPage=false, 
            isMobile=false,
            isConnectedFast,
            itemCollections,
            itemSelections,
            itemSelectionsDisplay,
            cinemaDataFront,
            movies,
            advertisements,
            ads,
            features,
            highlights,
            weischerAds,
            theme,
            routesData,
            translation,
            advertisementConfig,
            siteHeaderData,
            frontMobileSetting
        } = this.props

        const {
            program_overview_showtimes_type,
            header_appearance,
            content_width,
            highlight_appearance,
            stripe_appearance,
            slider_appearance,
            small_slider_appearance,
            show_availableIn,
            program_overview_startview_type,
            program_overview_subtitle,
            has_showtimes_feature,
            has_grid_trailer_feature,
            has_grid_hover_trailer
        } = cinemaDataFront

        const {has_chatbot} = features
        const {theme_colors} = theme
        const {main_slider_advertisement_positioning} = advertisementConfig

        const cookieExists = getCookie('fireplace')
        const isScrolledClass = this.state.isScrolled || cookieExists ? ' is-scrolled' : ''
        const languages = translation.languages ? translation.languages : {de: {}}
        const filteredWeischerAds =  filterWeischerAds(weischerAds, [WEISCHER_OVERVIEW_HERO])
        const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_OVERVIEW_HERO]) 
        const overviewHeroItems = filteredWeischerAds[WEISCHER_OVERVIEW_HERO]
        const overviewHeroAdvertisementItems = filteredAdvertisements[ADVERTISEMENT_OVERVIEW_HERO]
        
        return (
            <BrowserRouter>
                {isOverviewPage ? Object.keys(languages).map(langKey => {
                    const langPath = translation.defaultLang === langKey ? '' : '/' + langKey

                    return ([
                        <Route 
                            key={langKey + 'overview'}
                            path={langPath + "/:overviewParam"}
                            exact={true}
                            render={props => (
                                <PageFrontOverviewWrapper 
                                    location={props.location}
                                    match={props.match}
                                    ads={ads}
                                    showAvailableIn={show_availableIn}
                                    advertisements={advertisements}
                                    hasChatbot={has_chatbot}
                                    headerAppearance={header_appearance}
                                    contentWidth={content_width}
                                    isOverviewPage={isOverviewPage}
                                    isMobile={isMobile}
                                    isScrolledClass={isScrolledClass}
                                    overviewSubtitle={program_overview_subtitle}
                                    highlights={highlights}
                                    sliderAppearance={slider_appearance}
                                    stripeAppearance={stripe_appearance}
                                    programOverviewShowtimesType={program_overview_showtimes_type}
                                    highlightAppearance={highlight_appearance}
                                    smallSliderAppearance={small_slider_appearance}
                                    weischerAds={weischerAds}
                                    customMobilePage={frontMobileSetting}
                                    theme={theme_colors}
                                    movies={movies}
                                    siteHeaderData={siteHeaderData}
                                    programOverviewStartviewType={program_overview_startview_type}
                                    mainSliderAdvertisementPositioning={main_slider_advertisement_positioning}
                                    itemSelectionsDisplay={itemSelectionsDisplay}
                                    itemSelections={itemSelections}
                                    itemCollections={itemCollections}
                                    translation={translation}
                                    routesData={routesData}
                                    features={features}
                                    mobileOverview={true}
                                    hasShowtimesFeature={has_showtimes_feature}
                                    hasGridTrailerFeature={has_grid_trailer_feature}
                                    hasGridHoverTrailer={has_grid_hover_trailer}
                                    isConnectedFast={isConnectedFast}
                                />
                            )}
                        />,
                        
                        <Route
                            key={langKey + 'overview-movie'}
                            path={langPath + "/:overviewParam/movie/:movieParam"}
                            exact={true}
                            render={props => (
                                <PageOverviewMovie
                                    location={props.location}
                                    isOverviewPage={isOverviewPage}
                                    overviewHeroItems={overviewHeroItems}
                                    overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
                                    isScrolledClass={isScrolledClass}
                                    match={props.match}
                                    isConnectedFast={isConnectedFast}
                                />
                            )}
                        />
                    ])
                }): (
                    <Route 
                    render={(props) => (
                        <PageFrontOverviewWrapper 
                            location={props.location}
                            match={props.match}
                            ads={ads}
                            programOverviewShowtimesType={program_overview_showtimes_type}
                            advertisements={advertisements}
                            headerAppearance={header_appearance}
                            contentWidth={content_width}
                            isOverviewPage={isOverviewPage}
                            overviewSubtitle={program_overview_subtitle}
                            isMobile={isMobile}
                            showAvailableIn={show_availableIn}
                            isScrolledClass={isScrolledClass}
                            highlights={highlights}
                            hasChatbot={has_chatbot}
                            sliderAppearance={slider_appearance}
                            stripeAppearance={stripe_appearance}
                            highlightAppearance={highlight_appearance}
                            smallSliderAppearance={small_slider_appearance}
                            weischerAds={weischerAds}
                            customMobilePage={frontMobileSetting}
                            theme={theme_colors}
                            movies={movies}
                            siteHeaderData={siteHeaderData}
                            programOverviewStartviewType={program_overview_startview_type}
                            mainSliderAdvertisementPositioning={main_slider_advertisement_positioning}
                            itemSelectionsDisplay={itemSelectionsDisplay}
                            itemSelections={itemSelections}
                            itemCollections={itemCollections}
                            translation={translation}
                            routesData={routesData}
                            features={features}
                            mobileOverview={true}
                            hasShowtimesFeature={has_showtimes_feature}
                            hasGridTrailerFeature={has_grid_trailer_feature}
                            hasGridHoverTrailer={has_grid_hover_trailer}
                            isConnectedFast={isConnectedFast}                        
                        />
                    )}/>
                )
                }
            </BrowserRouter>
        )
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(withUseCssVars(withLatencyTest(PageFrontOverview)))